import type { NextPage } from 'next'
import ErrorPage from 'templates/Error'

const MaintenancePage: NextPage = (): JSX.Element => {
  return <ErrorPage type="partners-maintenance" />
}

export default MaintenancePage
